import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Accueil", target: "home", testid: "nav-link-home" },
  { label: "Notre Équipe", target: "equipe", testid: "nav-link-equipe" },
  { label: "Nos Spécialités", target: "specialites", testid: "nav-link-specialites" },
  { label: "Nos Traitements", target: "traitements", testid: "nav-link-traitements" },
  { label: "Contact", target: "contact", testid: "nav-link-contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAF8F5]/85 backdrop-blur-xl border-b border-[#E8DED5]/60"
          : "bg-transparent"
      }`}
    >
      <div className="container-xl flex items-center justify-between h-20">
        <button
          onClick={() => scrollTo("home")}
          data-testid="logo-home"
          className="flex flex-col items-start leading-none text-left"
        >
          <span className="font-serif text-2xl sm:text-[26px] text-[#2D241E] tracking-tight">
            Cabinet Dentaire
          </span>
          <span className="font-serif italic text-[#BE6C42] text-lg -mt-1">
            La Gavotte
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.target}
              onClick={() => scrollTo(l.target)}
              className="nav-link"
              data-testid={l.testid}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button
            onClick={() => scrollTo("equipe")}
            className="btn-primary"
            data-testid="nav-cta-rdv"
          >
            Prendre RDV
          </button>
        </div>

        <button
          className="lg:hidden p-2 text-[#2D241E]"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden bg-[#FAF8F5]/98 backdrop-blur-xl border-t border-[#E8DED5]"
          data-testid="mobile-menu"
        >
          <div className="container-xl py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.target}
                onClick={() => scrollTo(l.target)}
                className="nav-link text-left text-lg"
                data-testid={`mobile-${l.testid}`}
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo("equipe")}
              className="btn-primary justify-center mt-2"
              data-testid="mobile-nav-cta-rdv"
            >
              Prendre RDV
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
